module.exports = __webpack_public_path__ + "img/375.0efd8a00.jpg";